import { Skeleton } from '@/components/ui/skeleton';
import TabBar from '@/components/features/TabBar';

const TAB_BAR_HEIGHT = 56;

export function Profile101Skeleton() {
  return (
    <div 
      data-testid="profile-101-skeleton"
      className="h-[100dvh] w-full overflow-hidden flex justify-center bg-bg-primary"
    >
      <div className="relative w-full max-w-[420px] h-[100dvh] overflow-hidden flex flex-col bg-bg-primary">
        <div className="h-[env(safe-area-inset-top,0px)]" />
        
        <div 
          className="flex-1 overflow-y-auto scrollbar-hide px-screen-padding"
          style={{ paddingBottom: `calc(env(safe-area-inset-bottom) + ${TAB_BAR_HEIGHT}px + 16px)` }}
        >
          {/* Header skeleton - 4 buttons */}
          <div className="flex items-center justify-between py-m">
            <Skeleton className="w-11 h-11 rounded-full" />
            <div className="flex items-center gap-s">
              <Skeleton className="w-11 h-11 rounded-full" />
              <Skeleton className="w-11 h-11 rounded-full" />
              <Skeleton className="w-11 h-11 rounded-full" />
            </div>
          </div>

          {/* Avatar section */}
          <div className="flex flex-col items-center mt-m">
            <Skeleton className="w-[120px] h-[120px] rounded-full" />
            <Skeleton className="h-6 w-40 mt-4" />
            <Skeleton className="h-10 w-48 mt-3 rounded-full" />
          </div>

          {/* About section */}
          <div className="mt-6">
            <Skeleton className="h-4 w-20 mb-2" />
            <Skeleton className="h-16 w-full rounded-input" />
          </div>

          {/* Contact info section - 3 rows */}
          <div className="mt-6 space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-4">
                <Skeleton className="w-10 h-10 rounded-full flex-shrink-0" />
                <div className="flex-1">
                  <Skeleton className="h-3 w-24 mb-1" />
                  <Skeleton className="h-4 w-32" />
                </div>
              </div>
            ))}
          </div>

          {/* Quiz results section */}
          <div className="mt-6 p-4 bg-bg-secondary rounded-input flex items-center gap-3">
            <Skeleton className="w-5 h-5 rounded" />
            <div className="flex-1">
              <Skeleton className="h-5 w-32 mb-1" />
              <Skeleton className="h-4 w-48" />
            </div>
            <Skeleton className="w-5 h-5 rounded" />
          </div>

          {/* Action buttons skeleton */}
          <Skeleton className="h-14 w-full mt-6 rounded-input" />
          <Skeleton className="h-14 w-full mt-4 rounded-input" />
          <Skeleton className="h-14 w-full mt-4 rounded-input" />

          {/* Logout button */}
          <Skeleton className="h-[52px] w-full mt-8 rounded-button" />
        </div>
      </div>
      
      <TabBar />
    </div>
  );
}
